/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlUpdateEntityRequest
 */
export interface ControlUpdateEntityRequest {
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateEntityRequest
     */
    entity_domain?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateEntityRequest
     */
    entity_name?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlUpdateEntityRequest
     */
    data_sources?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlUpdateEntityRequest
     */
    domains?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlUpdateEntityRequest
     */
    ip_addresses?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ControlUpdateEntityRequest
     */
    keywords?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateEntityRequest
     */
    industry?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateEntityRequest
     */
    number_of_employees?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateEntityRequest
     */
    number_of_pii_records?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateEntityRequest
     */
    company_revenue?: string;
    /**
     * 
     * @type {string}
     * @memberof ControlUpdateEntityRequest
     */
    country_code?: string;
}

/**
 * Check if a given object implements the ControlUpdateEntityRequest interface.
 */
export function instanceOfControlUpdateEntityRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ControlUpdateEntityRequestFromJSON(json: any): ControlUpdateEntityRequest {
    return ControlUpdateEntityRequestFromJSONTyped(json, false);
}

export function ControlUpdateEntityRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlUpdateEntityRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'entity_domain': !exists(json, 'entity_domain') ? undefined : json['entity_domain'],
        'entity_name': !exists(json, 'entity_name') ? undefined : json['entity_name'],
        'data_sources': !exists(json, 'data_sources') ? undefined : json['data_sources'],
        'domains': !exists(json, 'domains') ? undefined : json['domains'],
        'ip_addresses': !exists(json, 'ip_addresses') ? undefined : json['ip_addresses'],
        'keywords': !exists(json, 'keywords') ? undefined : json['keywords'],
        'industry': !exists(json, 'industry') ? undefined : json['industry'],
        'number_of_employees': !exists(json, 'number_of_employees') ? undefined : json['number_of_employees'],
        'number_of_pii_records': !exists(json, 'number_of_pii_records') ? undefined : json['number_of_pii_records'],
        'company_revenue': !exists(json, 'company_revenue') ? undefined : json['company_revenue'],
        'country_code': !exists(json, 'country_code') ? undefined : json['country_code'],
    };
}

export function ControlUpdateEntityRequestToJSON(value?: ControlUpdateEntityRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'entity_domain': value.entity_domain,
        'entity_name': value.entity_name,
        'data_sources': value.data_sources,
        'domains': value.domains,
        'ip_addresses': value.ip_addresses,
        'keywords': value.keywords,
        'industry': value.industry,
        'number_of_employees': value.number_of_employees,
        'number_of_pii_records': value.number_of_pii_records,
        'company_revenue': value.company_revenue,
        'country_code': value.country_code,
    };
}

